import { graphql } from '@/generated/gql';

export const SUPPLIER_CONTACT_DETAILS_UPDATE_MUTATION = graphql(/* GraphQL */ `
  mutation SupplierContactDetailsUpdate($input: contact_insert_input!) {
    cmdi {
      insert_contact_one(
        object: $input
        on_conflict: {
          constraint: contact_pkey
          update_columns: [id, title, firstName, lastName, email, role, preferredLanguage]
        }
      ) {
        id
        supplierId
        title
        firstName
        lastName
        email
        role
        preferredLanguage
      }
    }
  }
`);
